export const achievementResourceType = "user_group_achievement" as const;
